import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Button from '@zg-rentals/multibrand-ui/lib/Button';

import './style.scss';

const propTypes = {
    pager: PropTypes.object,
    text: PropTypes.string,
    disabled: PropTypes.bool,
    onLoadMoreClick: PropTypes.func.isRequired,
};

const defaultProps = {
    pager: {
        startKey: 0,
        endKey: 0,
        hasMore: false,
    },
    text: 'Load more',
    disabled: false,
};

const InfiniteScroller = ({
    pager,
    text,
    disabled,
    onLoadMoreClick,
}) => {
    const { hasMore } = pager;

    const loadMoreBtnStyle = cx(
        'InfiniteScroller-Btn',
        { hidden: !hasMore },
    );

    const handleLoadMoreClick = () => {
        const { endKey } = pager;
        onLoadMoreClick(endKey);
    };

    return (
        <div className="InfiniteScroller">
            {hasMore && (
                <div className="InfiniteScroller-BtnContainer">
                    <Button
                        type="primary"
                        className={loadMoreBtnStyle}
                        onClick={disabled ? null : handleLoadMoreClick}
                        disabled={disabled}
                    >
                        {text}
                    </Button>
                </div>
            )}
        </div>
    );
};

InfiniteScroller.propTypes = propTypes;
InfiniteScroller.defaultProps = defaultProps;

export default InfiniteScroller;
